module.exports = __webpack_public_path__ + "static/media/analyze resume - 1.874a1cd6.png";